// extracted by mini-css-extract-plugin
module.exports = {"container":"empty-statistics_container__D73D8","title":"empty-statistics_title__2fzSx","text":"empty-statistics_text__3vqQZ","img":"empty-statistics_img__I8CdM"};